module.exports = __webpack_public_path__ + "static/img/green_02_2025.52e3895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/green_02_2025.jpg
// module id = y77g
// module chunks = 100